var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('banner-template',{attrs:{"onCancel":_vm.onCancel}},[(_vm.bannerComponent)?_c(_vm.bannerComponent,{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }